{
  "seo": {
    "title": "About CuriPop — Our Mission & Story",
    "description": "CuriPop was built by parents and educators to answer kids' biggest questions in a fun, safe, and age-appropriate way. Learn about our mission and team.",
    "keywords": "about curipop, kids education mission, educational platform for children, safe learning for kids",
    "jsonLdDescription": "Fun answers to kids' big questions about science, space, animals, and the world."
  },
  "hero": {
    "tagline": "Our Story",
    "titlePrefix": "About",
    "titleHighlight": "CuriPop",
    "subtitle": "Where curiosity meets answers. We're on a mission to fuel the natural wonder in every child."
  },
  "mission": {
    "titlePrefix": "Our",
    "titleHighlight": "Mission",
    "paragraph1": "We believe every child's question deserves a real answer. Our mission is to fuel curiosity by making knowledge accessible, engaging, and fun.",
    "paragraph2": "In a world full of quick searches and fleeting attention spans, we're building a space where discovery never ends and every \"why\" leads to a genuine \"wow!\"",
    "imageAlt": "Children learning together",
    "badge": {
      "value": "1,000+",
      "label": "Questions"
    }
  },
  "approach": {
    "titlePrefix": "How CuriPop",
    "titleHighlight": "Supports Learning",
    "subtitle": "We focus on helping families build confidence, consistency, and curiosity through practical learning design.",
    "items": [
      {
        "title": "Safe, child-focused design",
        "description": "Every experience is built for children first, with parent oversight and zero distracting ad pressure."
      },
      {
        "title": "Learning that adapts",
        "description": "Reading support and profile settings help each child progress at the right pace with steady confidence."
      },
      {
        "title": "Parent visibility that matters",
        "description": "Families get clear progress insights so they can guide learning with practical next steps each week."
      }
    ],
    "summary": {
      "title": "1,000+ answers and growing",
      "description": "CuriPop helps families get trusted, age-appropriate answers across science, nature, space, history, and more.",
      "bullets": [
        "12 free questions daily for every family",
        "Family plan with up to 5 child profiles",
        "Parent insight and controls in one dashboard"
      ]
    }
  },
  "valuesSection": {
    "titlePrefix": "Our",
    "titleHighlight": "Values",
    "subtitle": "The principles that guide everything we do"
  },
  "values": {
    "items": [
      {
        "title": "Curiosity First",
        "description": "We believe every question is an opportunity to learn and grow. No question is too big or too small."
      },
      {
        "title": "Quality Content",
        "description": "Every answer is researched and crafted with care for young minds. Accuracy meets accessibility."
      },
      {
        "title": "Accessible Learning",
        "description": "Making knowledge fun, engaging, and easy to understand for everyone, everywhere."
      }
    ]
  },
  "story": {
    "titlePrefix": "Our",
    "titleHighlight": "Story",
    "paragraph1": "CuriPop was born from a simple observation: kids ask amazing questions. Questions that deserve more than a quick Google search or a dismissive \"I don't know.\"",
    "paragraph2": "We set out to create a place where every \"why?\" leads to a real answer—one that's clear, accurate, and engaging. A place where curiosity is celebrated and learning feels like an adventure.",
    "paragraph3": "Today, we're proud to serve thousands of curious families around the world, adding new questions every week and constantly improving how we help young minds discover the wonders of our world.",
    "imageAlt": "Children exploring and learning"
  },
  "team": {
    "titlePrefix": "Meet the",
    "titleHighlight": "Team",
    "subtitle": "Parents, educators, and dreamers building something special",
    "items": [
      {
        "role": "Founder & CEO",
        "description": "Mom of 2 curious kids, focused on keeping every answer accurate, safe, and easy for families to trust."
      },
      {
        "role": "Head of Content",
        "description": "Former science museum educator translating complex topics into clear, age-appropriate explanations kids enjoy."
      },
      {
        "role": "Technical Solutions Consultant",
        "description": "Technical Solutions Consultant building reliable learning tools that keep every session smooth and engaging."
      }
    ]
  },
  "cta": {
    "title": "Join Our Community",
    "subtitle": "Start exploring with thousands of curious learners today!",
    "primary": "Start Exploring",
    "secondary": "Start Free"
  }
}
